module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/motherfatherson.6094eeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/motherfatherson.jpg
// module id = dfA8
// module chunks = 0